// @flow
import * as actionTypes from "../constants/actionTypes";
import type { Entities } from "../types/entities";

export type GetLanguagesAction = { type: "GET_LANGUAGES" };
export type GetLanguagesSuccessAction = {
  type: "GET_LANGUAGES_SUCCESS",
  payload: {
    entities: Entities
  }
};
export type GetLanguagesErrorAction = {
  type: "GET_LANGUAGES_ERROR",
  payload: { error: string }
};
export type SelectLanguageAction = {
  type: "SELECT_LANGUAGE",
  payload: { language: Object }
};
export type SetBrowserLanguageAction = {
  type: "SET_BROWSER_LANGUAGE",
  payload: { id: string }
};

export type Action =
  | GetLanguagesAction
  | GetLanguagesSuccessAction
  | GetLanguagesErrorAction
  | SelectLanguageAction
  | SetBrowserLanguageAction;

export function getLanguages() {
  return {
    type: actionTypes.GET_LANGUAGES
  };
}

export function getLanguagesSuccess(entities: Entities): Action {
  return {
    type: actionTypes.GET_LANGUAGES_SUCCESS,
    payload: {
      entities
    }
  };
}

export function getLanguagesError(error: string): Action {
  return {
    type: actionTypes.GET_LANGUAGES_ERROR,
    payload: {
      error
    }
  };
}

export function selectLanguage(language: Object): Action {
  return {
    type: actionTypes.SELECT_LANGUAGE,
    payload: {
      language
    }
  };
}

export function setBrowserLanguage(id: string): Action {
  return {
    type: actionTypes.SET_BROWSER_LANGUAGE,
    payload: {
      id
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/language.js